import { render } from "./directLossSaleForm.vue?vue&type=template&id=2c195a04&scoped=true"
import script from "./directLossSaleForm.vue?vue&type=script&lang=js"
export * from "./directLossSaleForm.vue?vue&type=script&lang=js"

import "./directLossSaleForm.vue?vue&type=style&index=0&id=2c195a04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c195a04"]])

export default __exports__